import Endpoint from 'modules/reports/orm/Endpoint'
import Model from 'modules/reports/orm/Model'
import Response from 'modules/reports/orm/Response'

export default class CreateEndpoint<RequestT, T extends Model, MetaT = {}> extends Endpoint<
  RequestT,
  T,
  MetaT
> {
  method = 'post'
  model: typeof Model

  process(response: Response<T, MetaT>): T {
    return new this.model().set(response.data) as T
  }
}
